import React from "react";
import { PromptFormPaneForm } from "./PromptFormPaneForm";
import { PromptExamplesField } from "./PromptFormInputs/PromptExamplesField";
import { PromptConfigOverwrite, PromptExample } from "./types";
import { isGoogle } from "./utils";

export type Props = {
  loading: boolean;
  selectedModelName: string;
  advancedParameters: {
    further_instructions: PromptExample[];
    examples_preface: string;
    config_overwrite: PromptConfigOverwrite;
  };
  collectAdvancedParameters: (
    parameters: Partial<{
      further_instructions: PromptExample[];
      examples_preface: string;
      config_overwrite: PromptConfigOverwrite;
    }>
  ) => void;
};

export const PromptFormAdvancedTab: React.FC<Props> = ({
  loading,
  selectedModelName,
  advancedParameters,
  collectAdvancedParameters,
}) => {
  const renderBody = (modelName: string): React.ReactNode => {
    return (
      <span data-testid="prompt-form-examples-tab-inputs">
        {!isGoogle(modelName) && (
          <PromptExamplesField
            examples={advancedParameters.further_instructions}
            updateExample={updateExample}
            addExample={addExample}
            removeExample={removeExample}
            preface={advancedParameters.examples_preface}
            updatePreface={updatePreface}
          />
        )}
      </span>
    );
  };

  const updateExample = (
    index: number,
    field: keyof PromptExample,
    value: string
  ): void => {
    const copyExamples = [...advancedParameters.further_instructions];
    copyExamples[index] = { ...copyExamples[index], [field]: value };
    collectAdvancedParameters({
      further_instructions: copyExamples,
    });
  };
  const addExample = (): void => {
    collectAdvancedParameters({
      further_instructions: [
        ...advancedParameters.further_instructions,
        { data: "", text: "" },
      ],
    });
  };
  const removeExample = (): void => {
    const copyExamples = [...advancedParameters.further_instructions];
    copyExamples.splice(-1, 1);
    collectAdvancedParameters({
      further_instructions: copyExamples,
    });
  };
  const updatePreface = (value: string): void => {
    collectAdvancedParameters({ examples_preface: value });
  };

  return (
    <PromptFormPaneForm
      isLoading={loading}
      testId="prompt-form-examples-settings"
    >
      {renderBody(selectedModelName)}
    </PromptFormPaneForm>
  );
};
